var l = function (r) {
    return r.primary = "primary", r.outline = "outline", r.text = "text", r.icon = "buttonIcon", r.filledOutline = "filledOutline", r;
  }(l || {}),
  e = function (r) {
    return r.initial = "initial", r.small = "small", r.medium = "medium", r.large = "large", r;
  }(e || {}),
  i = function (r) {
    return r.submit = "submit", r.reset = "reset", r.button = "button", r;
  }(i || {});
export { l as ButtonKind, e as ButtonSize, i as ButtonType };